export default __webpack_public_path__ + "static/media/payment.55d52aef.png";